export default __webpack_public_path__ + "static/buy_again-e319a9d38c8c95828672cdfe37af419f.png";